import React from 'react';
import styles from './AccordionItem.scss';
import PropTypes from 'prop-types';
import { ReactMarkdownDisplay } from '../../ReactMarkdownDisplay';
import ChevronDown from 'wix-ui-icons-common/ChevronDown';
import { Collapse, Text } from 'wix-style-react';

const AccordionItemTitle = ({ title, prefix }) =>
  typeof title === 'string' || typeof title === 'number' ? (
    <ReactMarkdownDisplay
      textSize="small"
      weight="normal"
      markdown={title}
      prefix={prefix}
      renderers={{
        paragraph: function customText(props) {
          return (
            props.children && (
              <Text
                className={styles.WSRTextHeight}
                ellipsis
                size="medium"
                weight="normal"
              >
                {props.children}
              </Text>
            )
          );
        },
      }}
    />
  ) : (
    title
  );

export const AccordionItem = React.memo(
  ({ dataHook, title, content, isOpen, toggleRow, id, prefix }) => (
    <div data-hook={dataHook} className={styles.titleContainer}>
      <div
        className={`${styles.title} ${isOpen && styles.openedTitle}`}
        onClick={() => toggleRow(id)}
      >
        <div className={styles.textTitle} data-hook="accordion-title">
          {title && <AccordionItemTitle prefix={prefix} title={title} />}
        </div>
        <span style={{ height: '24px' }} data-hook="accordion-item-button">
          <ChevronDown className={isOpen ? styles.buttonExpanded : ''} />
        </span>
      </div>
      <Collapse open={isOpen}>
        {isOpen && (
          <div
            className={`${styles.content} ${styles.exampleContent}`}
            data-hook="accordion-item-content"
          >
            {content}
          </div>
        )}
      </Collapse>
    </div>
  ),
);

AccordionItem.displayName = 'AccordionItem';

AccordionItem.propTypes = {
  dataHook: PropTypes.string,
  id: PropTypes.number,
  title: PropTypes.node,
  content: PropTypes.node,
  isOpen: PropTypes.bool,
  toggleRow: PropTypes.func,
  prefix: PropTypes.string,
};
